import $ from 'jquery';

class ReadMore {
  constructor(el) {
    this.$wrapper = $(el);
    this.$body = this.$wrapper.find('.js-read-more__body');
    this.$opener = this.$wrapper.find('.js-read-more__opener');
    this.$closer = this.$wrapper.find('.js-read-more__closer');
    this.hiddenClassName = 'u-hidden';
    this.fullTextDisplayClassName = this.$body.data('read-more-visible-class-name') || 'u-height-auto u-max-height-initial';
  }

  init = () => {
    this.$opener.on('click', (e) => {
      e.preventDefault();
      this.show();
    });
    this.$closer.on('click', (e) => {
      e.preventDefault();
      this.hide();
    });
  }

  show = () => {
    this.$body.addClass(this.fullTextDisplayClassName);
    this.$opener.addClass(this.hiddenClassName);
    this.$closer.removeClass(this.hiddenClassName);
    this.updateHiddenClass(false);
  }

  hide = () => {
    this.$body.removeClass(this.fullTextDisplayClassName);
    this.$opener.removeClass(this.hiddenClassName);
    this.$closer.addClass(this.hiddenClassName);
    this.updateHiddenClass(true);
  }

  updateHiddenClass = (isToHide) => {
    const method = isToHide ? 'addClass' : 'removeClass';

    this.$body.each((_, current) => {
      const $current = $(current);
      const hiddenClassName = $(current).data('read-more-body-hidden-class-name');
      if (hiddenClassName) {
        $current[method](hiddenClassName);
      }
    });
  }
}

export {
  ReadMore,
};
